export default __webpack_public_path__ + "static/media/holidays-red.fb724aef.svg";